import {Box} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {
  LeaderBoardCurrentUserInfoSkeleton,
  LeaderBoardTabsFilterSkeleton,
  ScrollabeListSkeleton,
} from './LoadingSections';

export const LeaderBoardTemplate = () => (
  <Grid spacing={1.75} container>
    <Box
      display={'flex'}
      flexDirection={'column'}
      sx={{
        width: '100%',
        height: '100vh',
        backgroundColor: 'transparent',
        borderRadius: '8px',
      }}>
      <LeaderBoardCurrentUserInfoSkeleton />
      {/* Text */}
      {/* LeaderBoardTabsFilterSkeleton */}
      <LeaderBoardTabsFilterSkeleton />
      {/* Leaderboard List */}
      <ScrollabeListSkeleton />
    </Box>
  </Grid>
);
